import React from 'react';
import OpenUserDetail from '../../../../../components/link/OpenUserDetail';
import { setColumnWidth, setNumberWithComma } from '../../../../../lib/common';
import { setDateFormat } from '../../../../../lib/moment';
import {
  ACCOUNT_USER_DEVICE_PUSH_STATUS_TEXT,
  ACCOUNT_USER_LOGIN_TYPE_TEXT,
  ACCOUNT_USER_STATUS_TEXT,
} from '../../../../../constants/service/app/accountUserConstants';
import { DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';

/**
 *  유저 랭킹 리스트 컬럼
 */
const columns = (data) => {
  const { list } = data;

  return [
    {
      accessor: 'userId',
      Header: '회원번호',
      fixed: 'left',
      Cell: (row) => <OpenUserDetail text={row.value} userId={row.value} />,
    },
    {
      accessor: 'status',
      Header: '계정상태',
      sortable: false,
      fixed: 'left',
      width: 170,
      Cell: (row) => ACCOUNT_USER_STATUS_TEXT[row.value] || '_',
    },
    {
      accessor: 'name',
      Header: '이름',
      fixed: 'left',
      width: setColumnWidth(list, 'name'),
    },
    {
      accessor: 'account',
      Header: '아이디',
      resizable: true,
      fixed: 'left',
      width: setColumnWidth(list, 'account'),
    },
    {
      accessor: 'purchaseAmount',
      Header: '기간내 총 구매금액',
      resizable: true,
      width: 170,
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'orderCount',
      Header: '기간내 총 구매횟수',
      resizable: true,
      width: 170,
    },
    {
      accessor: 'loginType',
      Header: '로그인 타입',
      width: 120,
      Cell: (row) => ACCOUNT_USER_LOGIN_TYPE_TEXT[row.value] || '_',
    },
    {
      accessor: 'referralCode',
      Header: '레퍼럴 코드',
      resizable: true,
      width: setColumnWidth(list, 'referralCode'),
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'smsPush',
      Header: 'sms 푸시동의',
      width: 100,
      Cell: (row) => ACCOUNT_USER_DEVICE_PUSH_STATUS_TEXT[row.value] || '_',
    },
    {
      accessor: 'createDate',
      Header: '가입일자',
      sortable: true,
      width: 320,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_DASH_FORMAT),
    },
  ];
};

export default columns;
